import { toaster } from '@optiaxiom/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useInstanceId } from '@frontend/hooks/useInstanceId';

import { agentExecutionsService } from '../services/agentExecutions';

type UseResumeWorkflowExecutionOptions = {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
};

export function useResumeWorkflowExecution(options?: UseResumeWorkflowExecutionOptions) {
  const { instanceId } = useInstanceId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (executionId: string) => {
      if (!instanceId) {
        return Promise.reject(new Error('Instance ID is required'));
      }
      return agentExecutionsService.resumeWorkflowExecution(instanceId, executionId);
    },
    onSuccess: () => {
      // Invalidate and refetch execution queries
      queryClient.invalidateQueries({ queryKey: ['agentExecutions'] });
      queryClient.invalidateQueries({ queryKey: ['executionDetails'] });

      toaster.create('Workflow execution resumed successfully', {
        intent: 'success',
      });

      options?.onSuccess?.();
    },
    onError: (error: Error) => {
      toaster.create(`Failed to resume workflow execution: ${error.message}`, {
        intent: 'danger',
      });

      options?.onError?.(error);
    },
  });
}
